import {
  AuthLayout,
  MainLayout,
  NotificationLayout,
  SecondLayout,
} from "@layouts";
import {
  AccessDenyPage,
  AllInstructorPage,
  ComingSoonPage,
  CourseDetailViewPage,
  Error404Page,
  ForgotPassword,
  InstructorProfileViewPage,
  SendFeedbackPage,
  ThankYouPage,
  CategoryManagementPage,
} from "@pages";
import { PrivateRoute } from "@routing/guards/privateRoute";
import React from "react";
import { Navigate, Route } from "react-router-dom";

const publics = (
  <Route element={<PrivateRoute authRequired={false} />}>
    <Route element={<AuthLayout />}>
      <Route path="/forgot-password" element={<ForgotPassword />} />,
    </Route>
    <Route element={<MainLayout />}>
      <Route path="/category-management" element={<CategoryManagementPage />} />
      <Route path="/course/:id" element={<CourseDetailViewPage />} />
      <Route
        path="/instructor-profile-view/:id"
        element={<InstructorProfileViewPage />}
      />
      <Route
        path="/live-streams"
        element={<Navigate to={"/coming-soon"} replace />}
      />
      <Route path="/all-instructors" element={<AllInstructorPage />} />
      <Route path="/send-feedback" element={<SendFeedbackPage />} />
    </Route>
    <Route element={<SecondLayout />}>
      <Route
        path="/term-of-use"
        element={<Navigate to={"/coming-soon"} replace />}
      />
      <Route
        path="/privacy-policy"
        element={<Navigate to={"/coming-soon"} replace />}
      />
    </Route>
    <Route element={<NotificationLayout />}>
      <Route path="/404" element={<Error404Page />} />
      <Route path="/coming-soon" element={<ComingSoonPage />} />
      <Route path="/thank-you" element={<ThankYouPage />} />
      <Route path="/access-denied" element={<AccessDenyPage />} />
      <Route path="*" element={<Error404Page />} />
    </Route>
  </Route>
);

export { publics };
